export enum EntityStoreKey {
  TellentMembers = 'TellentMembers',
}
